module.exports = __webpack_public_path__ + "static/media/error-not-found-background.e89ed931.png";